// Dynamically get hostname from current window location
export const getBaseUrl = (): string => {
  const hostname = window.location.hostname;
  // return `https://be.service.mesulink.de`;
  return "https://web.mesu.service.staging.247uptime.io";
  
};

export const getWebMqttUrl = (): string => {
  const hostname = window.location.hostname;
  return `wss://${hostname}:15676/ws`;
};

export const config_url = "247fn://mesutronic.de/";

export const base_url = getBaseUrl();
export const webmqtt_url_ssl = getWebMqttUrl();
